/**
 * Test IDs for QA automation.
 */
export const testIds = {
  analyticsDashboardSaveDashboard: "analytics-dashboard-save-dashboard",
  analyticsDashboardRemoveGraph: "analytics-dashboard-remove-graph",
} as const;
